import { render, staticRenderFns } from "./AddItemsComponent.vue?vue&type=template&id=68612c69"
import script from "./AddItemsComponent.vue?vue&type=script&lang=js"
export * from "./AddItemsComponent.vue?vue&type=script&lang=js"
import style0 from "./AddItemsComponent.vue?vue&type=style&index=0&id=68612c69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports